import { setup } from "web/entrypoints/common/setup";

import "web/entrypoints/main/baustein-main";
import "./css-main-rebrand";
import components from "web/entrypoints/main/react-main";

setup(components);
